import React, {useContext, useEffect, useRef, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {ReactComponent as CloseBtn} from "../../../../assets/icons/close.svg";
import PostLoginPostApi from "../../../../components/Api/PostLoginPostApi";
import PlusImage from "./../../../../assets/images/u_plus.png";

import RadioIcon from "./../../../../assets/icons/radio-icon.png";
import RadioIcon2 from "./../../../../assets/icons/radio_selected_icon.png";

import $ from "jquery";
import {useForm} from "react-hook-form";
import {useParams} from "react-router-dom";
import PostLoginGetApi from "../../../../components/Api/PostLoginGetApi";
import init from "../../AccessControl/Check";

import ExampleCustomCodeTemplate from "./../../../../sample-csv/custom-code-template.xlsx";
import UserBasicInfoContext from "../../../../components/Context/UserBasicInfoContext";
import {SUPER_ADMIN_CODE} from "../../ConstRole/ConstRole";
import FileUploadIcon from "../../../../assets/icons/UploadFileIcon.png";
import TrashIcon from "./../../../../assets/icons/red-delete.svg";
import CrossIcon from "./../../../../assets/icons/cross.svg";

import AddonsRemoveIcon from "./../../../../assets/icons/AddonsRemoveIcon.svg";

import {
    MAX_UPLOAD_FILE_SIZE,
    MAX_UPLOAD_FILE_SIZE_ERR_MSG,
    PRODUCT_IMAGE_D_W,
    PRODUCT_IMAGE_D_H,
    PRODUCT_IMAGE_D_RATION,
    PRODUCT_MORE_IMAGE,
} from "../../../../components/Constants/FileUpload";
import HashLoader from "react-spinners/HashLoader";
import MultiLevelDropdown from "../../../../components/Input/MultiLevelDropdown";
import SpecAttributes from "../../../../components/Input/SpecAttributes";


const StoreItemClone = () => {

    const pageName = "Store Item Clone";
    var isAccess = init(pageName);

    const navigate = useNavigate();
    const [previousData, setPreviousData] = useState({});
    const {id} = useParams();

    const {register, handleSubmit} = useForm();
    const [categoryList, setCategoryList] = useState([]);


    const [isLoad, setIsLoad] = useState(false);
    const {state} = useLocation();

    const [unitPrice, setUnitPrice] = useState();
    const [tradePrice, setTradePrice] = useState("");

    const [insideDeliveryCharge, setInsideDeliveryCharge] = useState("");
    const [outsideDeliveryCharge, setOutsideDeliveryCharge] = useState("");
    const [insideDeliveryTime, setInsideDeliveryTime] = useState("");
    const [outsideDeliveryTime, setOutsideDeliveryTime] = useState("");
    const [outsideDeliveryTimeEnd, setOutsideDeliveryTimeEnd] = useState("");
    const [deliveryNotes, setDeliveryNotes] = useState("");

    const [selectedGlobalCategory, setSelectedGlobalCategory] = useState("");
    const [specValue, setSpecValue] = useState({code: null, name: ""});

    // Variant Controls
    const [addonsIndex, setAddonsIndex] = useState(1);
    const [variantOptionIndex, setVariantOptionIndex] = useState(0);

    const userProfile = useContext(UserBasicInfoContext);

    const [dragActive, setDragActive] = useState(false);
    const inputRef = useRef(null);

    let isAdmin = userProfile?.user_type_id === SUPER_ADMIN_CODE;
    
    // triggers the input when the button is clicked
    const onButtonClick = () => {
        inputRef.current.click();
    };

    const [quantityInput, setQuantityInput] = useState("");
    const [existingAddons, setExistingAddons] = useState([]);


    // Edit Existing Addons
    const addonsItemNameEvent = (e) => {
        let s = e.currentTarget.innerText ?? ""; 
        if (s.length >= 100 && !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key)) {
            e.preventDefault();
        }
        return;
    }

    const addonsItemPriceEvent = (e) => {
        let s = e.currentTarget.innerText ?? "";

        const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"];
        if (s.length >= 5 && !allowedKeys.includes(e.key)) {
            e.preventDefault();
            return;
        }

        if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
            e.preventDefault();
        }
        return;
    }


    const addonsItemQtyEvent = (e) => {
        let s = e.currentTarget.innerText ?? ""; 

        const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"];
        if (s.length >= 5 && !allowedKeys.includes(e.key)) {
            e.preventDefault();
            return;
        }

        if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
            e.preventDefault();
        }
        return;
    }
    

    // Get Item details
    useEffect(() => {
        try {
            PostLoginGetApi(`item/${id}`, "", 2)
                .then((responseJSON) => {
                    let response = JSON.stringify(responseJSON);
                    response = JSON.parse(response);

                    if (response["status"] === 1) {
                        let responseData = JSON.stringify(response["data"]);
                        responseData = JSON.parse(responseData);

                        if (responseData["code"] === 200) {
                            setPreviousData(responseData["data"]);
                            setUnitPrice(responseData["data"].unit_price_raw ?? 0);

                            if (responseData["data"].trade_price !== null) {
                                setTradePrice(responseData["data"].trade_price_raw);
                            }

                            setTimeout(() => {

                                // More Image Handler
                                let existing_image_arr = [];
                                responseData["data"]?.more_images?.map((val, i)=> {
                                    return existing_image_arr[i] = val;
                                });

                                setMoreFile(existing_image_arr);

                                if (responseData["data"]?.addons?.length > 0) {
                                    $("#custom_quantity_div").hide();
                                }

                                setQuantityInput(responseData["data"].stock_quantity);

                                $("#itemCategory").val(responseData["data"].category_id);
                                $("#unit").val(responseData["data"].unit ?? "");

                                setInsideDeliveryCharge(responseData["data"]?.delivery?.charge_inside);
                                setOutsideDeliveryCharge(responseData["data"]?.delivery?.charge_outside);
                                setInsideDeliveryTime(responseData["data"]?.delivery?.time_inside);
                                setOutsideDeliveryTime(responseData["data"]?.delivery?.time_outside_start_range);
                                setOutsideDeliveryTimeEnd(responseData["data"]?.delivery?.time_outside_end_range);
                                setDeliveryNotes(responseData["data"]?.delivery?.note);
                                setSelectedGlobalCategory(responseData["data"].global_category?.id);


                                let addons = JSON.stringify(responseData["data"]?.addons) ?? [];
                                if (addons?.length > 5) {
                                    addons = JSON.parse(addons, true);
                                    setAddonsIndex((prev)=>{
                                        return prev + (addons?.length ?? 0);
                                    });

                                    setExistingAddons(addons);

                                    let total_addons_options = 1;
                                    addons?.forEach((val)=>{
                                        total_addons_options += parseInt((val?.items?.length ?? 0));
                                    });
                                    setVariantOptionIndex(total_addons_options);
                                }


                                if (selectedGlobalCategory !== null) {
                                    let attributeData = responseData["data"].global_category?.spec_attributes_items;
                                    if (attributeData) {
                                        let specAttributeValueObject = {};

                                        attributeData.forEach((specAttribute) => {
                                            if (specAttribute.selected) {
                                                specAttributeValueObject[specAttribute.id] = {
                                                    code: specAttribute.selected.value_id,
                                                    name: specAttribute.selected.value,
                                                };
                                            }
                                        });

                                        setSpecValue(specAttributeValueObject)
                                    }
                                }

                                if( document.location.href?.includes("section=quantity") ) {
                                    $([document.documentElement, document.body]).animate({
                                        scrollTop: $("#edit_quantity_div").offset().top
                                    }, 800);
                                }

                            }, 1000);

                            setIsLoad(true);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (ex) {
            console.log(ex);
        }

        
        // Get Category Lists
        PostLoginGetApi("category", "", 2)
            .then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200) {
                        setCategoryList(responseData["data"]);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);


    const tradePriceChange = (event) => {
        const tp_price = event.target.value.replace(/\D/g, "");
        setTradePrice(tp_price);
    };

    const unitPriceChange = (event) => {
        const result = event.target.value.replace(/\D/g, "");
        setUnitPrice(result);
    };

    let reqBody = new FormData();

    const fileInput = useRef();
    const [file, setFile] = useState();
    const [fileData, setFileData] = useState();

    const [moreFile, setMoreFile] = useState([]);
    

    const [isDeliveryInfo, setIsDeliveryInfo] = useState(false);

    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    // Triggers when file is dropped
    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();

        handleMoreImage(e, 1);
        setDragActive(false);
    };

    const removeMoreImage = (inx) => {
        let arr = [];
        moreFile.forEach((val, i) => {
        if (i !== inx) {
            arr.push(val);
        }
        });

        $(".select_more_image").html("");
        setMoreFile(arr);
    };
    window.removeMoreImage = removeMoreImage;


    const quantityInputHandler = (event) => {
        const res2 = event.target.value.replace(/\D/g, "");
        if (res2 > 0) {
            $("#current_quantity").html(res2);
            setQuantityInput(res2);
        } else {
            $("#current_quantity").html("");
            setQuantityInput("");
        }
    };

    const insideDeliveryChargeHandler = (event) => {
        const insideDeliveryCharge = event.target.value.replace(/\D/g, "");
        setInsideDeliveryCharge(insideDeliveryCharge);
    };

    const outsideDeliveryChargeHandler = (event) => {
        const outsideDeliveryCharge = event.target.value.replace(/\D/g, "");
        setOutsideDeliveryCharge(outsideDeliveryCharge);
    };

    const insideDeliveryTimeHandler = (event) => {
        const insideDeliveryTime = event.target.value.replace(/\D/g, "");
        setInsideDeliveryTime(insideDeliveryTime);
    };

    const outsideDeliveryTimeHandler = (event) => {
        const outsideDeliveryTime = event.target.value.replace(/\D/g, "");
        setOutsideDeliveryTime(outsideDeliveryTime);
    };

    const outsideDeliveryTimeHandlerEnd = (event) => {
        const outsideDeliveryTime = event.target.value.replace(/\D/g, "");
        setOutsideDeliveryTimeEnd(outsideDeliveryTime);
    };

    const [loading, setLoading] = useState(false);

    const onSubmit = (data) => {

        let is_valid = true;

        let category = $("#itemCategory").val();
        let itemName = data.itemName;
        let unit = $("#unit").val() ?? data.unit;
        let sku = data.sku;

        // let low_stock_alert = data.low_stock_alert;
        let is_popular = data.is_popular;
        

        // Delivery Information
        let apply_delivery_info_on = $("#apply_delivery_info").prop("checked") ?? false;
        if ( apply_delivery_info_on === true ) {
            if (insideDeliveryCharge === "") {
                toast.error("Please input inside delivery charge");
                return;
            }
            if (outsideDeliveryCharge === "") {
                toast.error("Please input out side delivery charge");
                return;
            }

            if (insideDeliveryTime === "") {
                toast.error("Please input inside delivery time");
                return;
            }
            if (outsideDeliveryTime === "") {
                toast.error("Please input out side delivery time");
                return;
            }

            reqBody.append("inside_delivery_charge", insideDeliveryCharge);
            reqBody.append("outside_delivery_charge", outsideDeliveryCharge);
            reqBody.append("inside_delivery_time", insideDeliveryTime);
            reqBody.append("outside_delivery_time", outsideDeliveryTime);
            reqBody.append("outside_delivery_time_end", outsideDeliveryTimeEnd);
            reqBody.append("outside_delivery_time_end", outsideDeliveryTimeEnd);
            reqBody.append("delivery_info_notes", deliveryNotes);
            reqBody.append("apply_delivery_info", 1);
        }


        let low_stock_alert_on = $("#apply_item_or_category").prop("checked") ?? true ;
        if ( low_stock_alert_on === true ) {
            reqBody.append("low_stock_alert", data.low_stock_alert);
        }


        if(previousData.is_code) {
            if (file2 === undefined) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#custom_code_div").offset().top
                }, 1000, function() {
                    $("#custom_code_div").addClass("highlight-effect");

                    setTimeout(function() {
                        $("#custom_code_div").removeClass("highlight-effect");
                    }, 2000);
                });

                toast.error("Please upload valid Code CSV.");
                return;
            }

            reqBody.append("custom_code_csv", file2);
        }
        else {
            if(quantityInput <= 0) {
                toast.error("Please enter quantity.");
                $("#quantity").focus();

                return;
            }


            // Addons Mapping
            let duplicate_arr = [];
            let addons = $(".addons_box");
            addons?.each((i)=> {
                let addons_name = addons.eq(i).find('input[name="variant_name"]')?.val() ?? "";
                if( i > 0 ) {
                    if( addons_name === "" ) {
                        is_valid = false;
                        return toast.error("Variant name can not be empty.");
                    }
                }

                if( addons_name !== "" ) {

                    if( duplicate_arr?.indexOf(addons_name) >= 0 ) {
                        is_valid = false;
                        return toast.error("Variant name can not be duplicate : " + addons_name);
                    }
    
                    // Form Data Setup : Addons
                    reqBody.append("addons[" + i + "][is_required]", 1);
                    reqBody.append("addons[" + i + "][is_radio_button]", 1);
                    reqBody.append("addons[" + i + "][name]", addons_name);
    
                    let addons_item_quantity_sum = 0;
                    let addons_items = $(".variant-option-fixed").eq(i).find("span.variant_options_items");
                    addons_items?.each((j)=>{
                        let addons_item_name = addons_items.eq(j).find("div.addons-item-name")?.html() ?? "";
                        let addons_item_price = addons_items.eq(j).find("span.addons-item-price")?.html() ?? 0;
                        let addons_item_qty = addons_items.eq(j).find("span.addons-item-quantity")?.html() ?? 0;

                        if( addons_item_price === 0 || addons_item_price === "") {
                            is_valid = false;
                            return toast.error(`Variant item price empty for : ${addons_name?.toUpperCase()} > ${addons_item_name}`);
                        }

                        if( addons_item_qty === 0 || addons_item_qty === "") {
                            is_valid = false;
                            return toast.error(`Variant item quantity empty for : ${addons_name?.toUpperCase()} > ${addons_item_name}. Please remove if no stock available.`);
                        }
    
                        if( is_valid === true ) {
                            addons_item_quantity_sum += parseInt(addons_item_qty);
        
                            // Image Mapping
                            let addons_item_image_arr = [];
                            let addons_item_images = addons_items.eq(j).find("div.vi-selected");
                            
                            addons_item_images?.each((k)=>{
                                addons_item_image_arr.push(addons_item_images.eq(k)?.attr("id"));
                            });
        
        
                            // Form Data Setup : Addons
                            reqBody.append("addons[" + i + "][items][" + j + "][id]", (j+1));
                            reqBody.append("addons[" + i + "][items][" + j + "][name]", addons_item_name);
                            reqBody.append("addons[" + i + "][items][" + j + "][unit_price]", addons_item_price);
                            reqBody.append("addons[" + i + "][items][" + j + "][quantity]", addons_item_qty);
                            reqBody.append("addons[" + i + "][items][" + j + "][images]", addons_item_image_arr);
                        }
                    });
    
    
                    if( addons_item_quantity_sum !== parseInt(quantityInput) ) {
                        if(is_valid===true) {
                            toast.error(`Variant item quantity and stock quantity mismatch for : ${addons_name?.toUpperCase()}`);
                        }
                        is_valid = false;
                        return;
                    }
                    
                    duplicate_arr.push(addons_name);
                }
            });

                
            if( is_valid === false ) {
                return;
            }
        }


        reqBody.append("category_id", category);
        reqBody.append("name", itemName);
        reqBody.append("unit", unit);
        reqBody.append("unit_price", unitPrice);
        reqBody.append("trade_price", tradePrice);
        reqBody.append("description", data.description);
        reqBody.append("sku", sku);
        if( previousData.is_code === false ) {
            reqBody.append("stock_quantity", quantityInput);
        }
        
        reqBody.append("is_popular", is_popular);
        reqBody.append('global_category_id', selectedGlobalCategory);
        reqBody.append('attributeValues', JSON.stringify(specValue));
        reqBody.append("searchTag", $("#searchTag").val() ?? "");


        if (fileData !== undefined) {
            reqBody.append("image", fileData);
        }

        moreFile?.map(async (val, i) => {
            reqBody.append(`more_image[${i}]`, val);
        });


        $("#submit_loader_div").removeClass("hidden");
        $("#submit_btn_div").hide();


        //  Update Item API
        PostLoginPostApi(`item-clone/${id}`, reqBody, 1, 1).then((responseJSON) => {

            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Item created successfully.");
                    return navigate("/dashboard/store/items-details", {
                        state: {
                            itemId: responseData.data.id,
                        },
                    });
                }


                let message = responseData["messages"] ?? responseData["message"] ?? "A problem occur. Please try again.";
                toast.error(message + " ");
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            $("#submit_loader_div").addClass("hidden");
            $("#submit_btn_div").show();
            return;
        });
        
    };

    const deliveryInfoSwitch = (event) => {
        $("#apply_delivery_info_div").addClass("hidden");
        if (event.target.checked === true) {
            $("#apply_delivery_info_div").removeClass("hidden");
        }
        
        setIsDeliveryInfo((current) => !current);
    };

    const lowStockSwitch = (event) => {
        $("#low_stock_alert_div").hide();
        if(event.target.checked === true) {
            $("#low_stock_alert_div").show();
        }
    };

    useEffect(() => {
        $("#low_stock_alert_div").addClass("hidden");
        if (previousData.low_stock_alert > 0) {
            $("#low_stock_alert_div").removeClass("hidden");
        }
    }, [previousData.low_stock_alert]);

    const selectFile = () => {
        fileInput.current.click();
    };


    const handleChange = () => {
        const file = fileInput.current.files[0];
        if (
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "image/jpeg" ||
            file.type === "image/svg" ||
            file.type === "image/webp"
        ) {
            if (file.size > MAX_UPLOAD_FILE_SIZE) {
                toast.error("Max upload file size is 1 MB.");
                return;
            }

            let img = new Image();
            img.src = window.URL.createObjectURL(file);
            img.onload = async () => {
                let w = img.width, h = img.height;

                if (w < PRODUCT_IMAGE_D_W || h < PRODUCT_IMAGE_D_H) {
                    toast.error("Please upload image with proper dimension : " + PRODUCT_IMAGE_D_W + " x " + PRODUCT_IMAGE_D_H
                        + "\r" + (file['name'].substring(0, 25) + ".." ?? "")
                    );
                } else {
                    let r = parseFloat(w / h).toFixed(2);
                    if (r !== PRODUCT_IMAGE_D_RATION) {
                        toast.error("Please upload image with valid ratio (w/h) : " + parseInt(PRODUCT_IMAGE_D_RATION) + "\r\n" + (file['name'].substring(0, 25) + ".." ?? ""));
                    } else {
                        setFile(img.src);
                        setFileData(file);
                    }
                }
            };


            return;
        }

        toast.error("Please choose valid file type.");
    };

    // Handle More Images
    const handleMoreImage = async (e, is_drag = 0) => {
        let file = null,
            len = 0;

        if (is_drag === 1) {
            len = e.dataTransfer.files.length ?? 0;
            file = e.dataTransfer.files ?? null;
        } else {
            len = e.target.files.length ?? 0;
            file = e.target?.files ?? null;
        }

        if (len === 0) {
            return;
        }

        let existing = moreFile?.length ?? 0;
        if (existing + len > PRODUCT_MORE_IMAGE) {
            toast.error("Photo limit exceed : max " + PRODUCT_MORE_IMAGE);
            return;
        }

        for (let i = 0; i < len; i++) {
            if (file[i]["size"] > MAX_UPLOAD_FILE_SIZE) {
                toast.error(
                    MAX_UPLOAD_FILE_SIZE_ERR_MSG.toString() +
                    "\r" +
                    (file[i]["name"].substring(0, 25) + ".." ?? "")
                );
                continue;
            }

            if (!file[i]["type"].includes("image/")) {
                toast.error("Please upload valid Image file.");
                return;
            }

            let img = new Image();
            img.src = window.URL.createObjectURL(file[i]);
            img.onload = async () => {
                let w = img.width,
                    h = img.height;

                if (w < PRODUCT_IMAGE_D_W || h < PRODUCT_IMAGE_D_H) {
                    toast.error(
                        "Please upload image with proper dimension : " +
                        PRODUCT_IMAGE_D_W +
                        " x " +
                        PRODUCT_IMAGE_D_H +
                        "\r" +
                        (file[i]["name"].substring(0, 25) + ".." ?? "")
                    );
                } else {
                    let r = parseFloat(w / h).toFixed(2);
                    if (r !== PRODUCT_IMAGE_D_RATION) {
                        toast.error("Please upload image with valid ratio (w/h) : " + PRODUCT_IMAGE_D_RATION + "\r" + (file[i]["name"].substring(0, 25) + ".." ?? ""));
                    } 
                    else {
                        setMoreFile((prev) => {
                            $(".select_more_image").html("");
                            return [...prev, file[i]];
                        });
                    }
                }
            };
        }
    };

    useEffect(() => {
            if (previousData.image !== undefined && previousData.image !== "") {
                setFile(previousData.image);
            }

        }, [previousData.image]);
    


    const fileInput2 = useRef();
    const [file2, setFile2] = useState();

    const selectFile2 = () => {
        fileInput2.current.click();
    };

    const handleChange2 = (e) => {
        if (!e.target?.files[0]) {
            return;
        }

        if (e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("application/vnd.")) {
            toast.error("Please upload valid excel");
            return;
        }

        setFile2(e.target.files[0]);
    };



    const searchTagEvent = (val) => {
        let res = "";
        for (var i = 0; i < Math.min(val.length, 255); i++) {
            if (val[i] === " ") {
                continue;
            }

            if (isNaN(val[i]) === false) {
                res += val[i];
            }

            if (
                (val[i] >= "A" && val[i] <= "Z") ||
                (val[i] >= "a" && val[i] <= "z")
            ) {
                res += val[i];
            }
        }

        $("#searchTag").val(res.replace(/\s/g, ""));
        return;
    };


    
    // Update Low Stock Alert
    const handleUpdateLowStock = (is_message = 1) => {
        PostLoginPostApi("item/low-stock/" + id, JSON.stringify({low_stock_alert: $("#low_stock_alert").val()}), 1, 0).then((responseJSON) => {
            if (is_message === 1) {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200) {
                        toast.success(responseData["messages"].toString() ?? "Low stock alert info update successfully.");
    
                        // setTimeout(() => {
                        //     window.location.reload();
                        // }, 2000);
    
                        return;
                    }
    
                    toast.error(responseData["messages"].toString() ?? "A problem occur. Please try again.");
                }
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };

    // Addons Control
    const addMoreVariant = () => {
        let addonsDataDom = `<div id="addons_box_${addonsIndex}" class="addons_box block border border-[#e5e7eb] rounded-md py-5 px-4 mt-4 w-full">
            
            <span class="float-left" style="font-size: 14px; padding-left: 4px;">Variant Name</span>
            <div onClick="removeVariantBox(`+addonsIndex+`)" class="text-[#FD171B] flex float-right items-center font-semibold cursor-pointer close-btn">
                <img src="${AddonsRemoveIcon}" alt="Img" />
                <span class="ml-1 text-[12px] float-right">Remove</span>
            </div>

            <div class="w-full flex">
                <div class="flex items-center pt-2 w-full">
                    <input type="text" id="variant_name_${addonsIndex}" name="variant_name" onKeyDown="onEnterAddonsName(event)" placeholder="Variant Name" class="variant_name w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-[#75b1f1] dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#75b1f1] peer" />

                    <span class="bg-[#E5F9EA] block text-[#009E22] ml-2.5 -mr-1 px-2 py-1 h-6 text-[10px] font-medium rounded-3xl">Required</span>
                </div>
            </div>

            <div id="variant-option-fixed_${addonsIndex}" class="variant-option-fixed py-3"></div>

            <div id="variant-option_${addonsIndex}" class="variant-option flex items-center mb-1">
                <img src="${RadioIcon2}" alt="Variant Option" class="vo_checkbox_icon h-[18px]" />
                <div class="flex justify-between w-full pl-2 gap-3 ">
                    <input type="text" name="variant-item" onKeyDown="onEnterAddonsItemName(event)" class="variant-item w-[64%] pl-0 variant-item border-transparent focus:border-[#75b1f1] focus:ring-0 mr-3" placeholder="Add Variant Item" maxLength="100" />

                    <div class="relative group w-[18%]">
                        <input type="text" name="add-price" onKeyDown="onEnterAddonsItemPrice(event)" class="peer add-price ml-2 w-full text-center border-transparent focus:border-[#75b1f1] focus:ring-0 focus:outline-none" placeholder="Price" maxLength="6" />
                        <div class="absolute top-full text-center mt-1 hidden w-full rounded bg-[#75b1f1] p-0.5 text-xs text-white group-hover:hidden peer-focus:block">Additional Price</div>
                    </div>

                    <input type="text" name="add-quantity" onKeyDown="onEnterAddonsItemQuantity(event, ${addonsIndex})" class="add-quantity ml-2 w-[18%] text-center border-transparent focus:border-[#75b1f1] focus:ring-0" placeholder="Quantity" maxLength="4" />
                </div>
            </div>
        </div>`;


        $("#addons_boxes").append(addonsDataDom);
        setAddonsIndex((prev)=>{return prev+1});
    }

    const removeVariantBox = (index) => {
        $("#addons_box_"+index).remove();
    }
    window.removeVariantBox = removeVariantBox;


    const clearFirstVariantBoxData = () => {
        let index = 0;
        $(".variant_name").eq(index).val("");
        $(".variant-option-fixed").eq(index).html("");
    }

    // Addons Control
    const onEnterAddonsName = (event) => {
        if(event.key === "Enter") {
            if( quantityInput === "" || quantityInput === null ) {
                $("#quantity").focus();
                return alert("Please enter stock quantity.");
            }

            let v = event.currentTarget.value;
            if( v === "" || v === null ) {
                return alert("Please enter valid variant name.");
            }

            $(event.target).parent().parent().parent().find('input[name="variant-item"]').focus();
        }
    };
    window.onEnterAddonsName = onEnterAddonsName;

    // Addons Items Control
    const onEnterAddonsItemName = (event) => {
        if(event.key === "Enter") {
            if( quantityInput === "" || quantityInput === null ) {
                $("#quantity").focus();
                return alert("Please enter stock quantity.");
            }

            let v = event.currentTarget.value;
            if( v === "" ) {
                return alert("Please enter variant item name.");
            }

            $(event.target).next().find("input").focus();
        }
    };
    window.onEnterAddonsItemName = onEnterAddonsItemName;
    
    const onEnterAddonsItemPrice = (event) => {
        if(event.key === "Enter") {
            let v = event.currentTarget.value;
            if( v === "" || isNaN(v) ) {
                return alert("Please enter valid item price.");
            }

            if( v < 0 ) {
                return alert("Price can not be less than 0.");
            }
            
            $(event.target).parent().next().closest('div').find('input[name="add-quantity"]')?.focus();
        }
    };
    window.onEnterAddonsItemPrice = onEnterAddonsItemPrice;

    const onEnterAddonsItemQuantity = (event, index) => {
        if(event.key === "Enter") {
        
            let v = event.currentTarget.value;
            if( v === "" || isNaN(v) ) {
                return alert("Please enter valid item quantity.");
            }

            if( v <= 0 ) {
                return alert("Quantity can not be zero.");
            }

            let n = $("#variant_name_"+index).val();
            if( n === "" ) {
                return alert("Please enter name.");
            }


            const div = document.getElementById("variant-option_"+index);
            const inputs = div.querySelectorAll('input');


            if( checkQuantity(index, parseInt(inputs[2].value)) === false ) {
                return alert("Total addons quantity can not exceed total quantity.");
            }

            let images = "";
            for (let i = 0; i < moreFile?.length; i++) {
                if( typeof(moreFile[i]) === "object" ) {
                    images += 
                    `
                    <div id="${i}" class='w-1/5 p-1 m-[0.5px] hover:bg-slate-400 cursor-pointer vmi-${i}'>
                        <img onClick="selectVariantImage(event)" src='${window.URL.createObjectURL(moreFile[i])}' alt='prev # ${i+1}' class='w-full block border border-x-blue-100' />
                    </div>
                    `;
                }
                else {
                    images += 
                    `
                    <div id="${i}" class='w-1/5 p-1 m-[0.5px] hover:bg-slate-400 cursor-pointer vmi-${i}'>
                        <img onClick="selectVariantImage(event)" src='${moreFile[i]}' alt='prev # ${i+1}' class='existing_image w-full block border border-x-blue-100' />
                    </div>
                    `;
                }
            }
                        
            let addonsItemDoc = 
            `
            <span id="variant_options_items_${variantOptionIndex}" class="variant_options_items">
                <div class="flex items-center pt-2">
                    <img src="${RadioIcon2}" alt="Variant Option" class="vo_radio_icon h-[18px]" />
                    <div class="flex justify-between w-full pl-2">
                        <div class="w-[64%] pl-0 pt-0.5 addons-item-name">`+inputs[0].value+`</div>
                        <div class="ml-2 w-[18%] pl-2 pt-1 text-center">
                            ৳ <span class="addons-item-price" style="margin-left:7px">`+inputs[1].value+`</span>
                        </div>
                        <div class="ml-2 w-[18%] pl-3 pt-1 text-center">
                            <span class="font-semibold">x</span>
                            <span class="addons-item-quantity" style="margin-left:7px">`+inputs[2].value+`</span>
                        </div>
                        <div onClick="removeVariantOption(`+variantOptionIndex+`)" class="h-6 w-6 flex items-center mt-1 cursor-pointer">
                            <img src="${CrossIcon}" alt="Img" />
                        </div>
                    </div>
                </div>
                <div id="select_more_image_${variantOptionIndex}" class="w-full flex mt-1 select_more_image">
                    `+images+`
                </div>
            </span>
            `;


            $("#variant-option-fixed_"+index).append(addonsItemDoc);
            setVariantOptionIndex((prev)=>{ return prev+1; });

            inputs.forEach(input => {
                input.value = '';
            });

            inputs[0]?.focus();

        }
    };
    window.onEnterAddonsItemQuantity = onEnterAddonsItemQuantity;

    const removeVariantOption = (index) => {
        $("#variant_options_items_"+index).remove();
    }
    window.removeVariantOption = removeVariantOption;
    

    // More Image Controller 
    useEffect(()=>{
        let images = "";
        for (let i = 0; i < moreFile?.length; i++) {
            if( typeof(moreFile[i]) === "object" ) {
                images += 
                `
                <div id="${i}" class='w-1/5 p-1 m-[0.5px] hover:bg-slate-400 cursor-pointer c'>
                    <img onClick="selectVariantImage(event)" src='${window.URL.createObjectURL(moreFile[i])}' alt='prev # ${i+1}' class='w-full block border border-x-blue-100' />
                </div>
                `;
            }
            else {
                images += 
                `
                <div id="${i}" class='w-1/5 p-1 m-[0.5px] hover:bg-slate-400 cursor-pointer'>
                    <img onClick="selectVariantImage(event)" src='${moreFile[i]}' alt='prev # ${i+1}' class='existing_image w-full block border border-x-blue-100' />
                </div>
                `;
            }
        }

        $(".select_more_image").html(images);
        
        // Image Selected
        setTimeout(()=>{ 
            addonsCheckSelectedImage() 
        }, 1000);

    }, [moreFile]);

    const selectVariantImage = (event) => {
        let img = event.target.parentElement;
        img.classList.toggle("vi-selected");
    }
    window.selectVariantImage = selectVariantImage;

    const checkQuantity = (index, req_q) => {
        let div = $("#addons_box_"+index).find(".addons-item-quantity");
        let addons_q = (parseInt( div.map((_, el) => parseFloat($(el).text()) || 0).get().reduce((a, b) => a + b, 0)) ?? 0) + req_q;
        let stock_q = quantityInput ?? 0;

        if( addons_q > stock_q ) {
            return false;
        }

        return true;
    }
    
    const updateDeliveryInfo = (delivery_id) => {

        if (insideDeliveryCharge === '' || insideDeliveryCharge === undefined) {
            toast.error("Please input inside delivery charge");
            return;
        }
        if (outsideDeliveryCharge === '' || outsideDeliveryCharge === undefined) {
            toast.error("Please input out side delivery charge");
            return;
        }

        if (insideDeliveryTime === '' || insideDeliveryTime === undefined) {
            toast.error("Please input inside delivery time");
            return;
        }

        if (outsideDeliveryTime === '' || outsideDeliveryTime === undefined) {
            toast.error("Please input out side delivery time");
            return;
        }

        if (outsideDeliveryTimeEnd === '' || outsideDeliveryTimeEnd === undefined) {
            toast.error("Please input out side delivery time end");
            return;
        }

        let arr = new FormData();
        arr.append("inside_delivery_charge", insideDeliveryCharge);
        arr.append("outside_delivery_charge", outsideDeliveryCharge);
        arr.append("inside_delivery_time", insideDeliveryTime);
        arr.append("outside_delivery_time", outsideDeliveryTime);
        arr.append("outside_delivery_time_end", outsideDeliveryTimeEnd);
        arr.append("delivery_info_notes", deliveryNotes);


        PostLoginPostApi("item/delivery_info/" + id + "/" + delivery_id, arr, 1, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success(responseData["messages"].toString() ?? "Delivery info update successfully.");

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);

                    return;
                }

                toast.error(responseData["messages"].toString());
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }

    
    const addonsCheckSelectedImage = () => {
        $(".existing_image").each((i)=>{
            let val = $(".existing_image").eq(i);
            let current_src = val?.attr("src");

            let div = val?.parent()?.parent()?.parent();
            if (div?.length > 0) {
                let ai = div.find(".addons-item-images")?.val();
                if( ai ) {
                    ai = JSON.parse(ai);
                    if(ai?.length > 0) {
                        if( ai?.indexOf(current_src) >= 0 ) {
                            val?.parent()?.addClass("vi-selected");
                        }
                    } 
                }
            }
        });
    }


    useEffect(() => {
        if (!isAdmin) {
            if (previousData?.is_publish !== true) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                isAdmin = true;
                // document.location.href = "/dashboard/store";
            }
        }

    }, [userProfile, previousData]);

// Get Measure of unit lists
    const [mou, setMou] = useState([]);
    useEffect(() => {
        PostLoginGetApi("mou/list-active", "", 3)
            .then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);

                    if (responseData["code"] === 200) {
                        setMou(responseData["data"]);
                        return;
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    if (isAccess === false) {
        return (
            <>
                <table className="custom-details-table w-full mt-0 mb-2">
                    <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                    </tbody>
                </table>
            </>
        );
    }

    return (
        <div className='flex justify-center items-center w-full h-screen'>
            {loading ?
                <HashLoader
                    color={"#1882FF"}
                    loading={loading}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                /> :

                <>
            {isLoad === true && (
                <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left">
                    <form
                        className="mb-5"
                        action=""
                        autoComplete="on"
                        method="POST"
                        encType="multipart/form-data"
                    >
                        <header className="flex justify-between fixed w-full z-[999] bg-white h-16  items-center p-4 border-b-2 border-dark-white">
                            <Link to="/dashboard/store" state={{ from: state }}>
                                <CloseBtn />
                            </Link>
                            <p className="-mr-24 text-xl text-black">Clone Item</p>
            
                            <div id="submit_btn_div">
                                <input
                                type="button"
                                value="Save Item"
                                onClick={handleSubmit(onSubmit)}
                                className="submit_btn bg-[#158560] text-white font-semibold py-2 px-5 rounded-sm hover:cursor-pointer hover:bg-green-500"
                                ></input>
                            </div>
                            <div id="submit_loader_div" className="pr-10 hidden">
                                Please wait...
                            </div>
                        </header>

                        <main className="max-w-2xl m-auto pt-[100px]">
                            <h1 className="text-xl">Item Basic Information</h1>

                            <div className="mt-[5px] mb-[15px]">
                                {/* Global Category Dropdown Start */}
                                <div className="relative pb-1 pt-1 mb-2">
                                    <MultiLevelDropdown
                                        selectedGlobalCategory={selectedGlobalCategory}
                                        setSelectedGlobalCategory={setSelectedGlobalCategory}
                                    />
                                </div>
                                {/* Global Category Dropdown End */}

                                <div className="relative pb-1 pt-1 my-4">
                                    <select
                                        name="itemCategory"
                                        id="itemCategory"
                                        {...register("itemCategory")}
                                        className="w-full rounded border-solid border border-dark-white"
                                        disabled={!isAdmin}
                                        required
                                    >
                                        <option value="" hidden>
                                            Select a category *
                                        </option>
                                        {categoryList.map((data, index) => (
                                            <option
                                                key={index}
                                                value={data.id}
                                                className="text-black"
                                            >
                                                {data.name}
                                            </option>
                                        ))}
                                    </select>

                                    <label
                                        htmlFor="itemCategory"
                                        className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                        Select Item Category *
                                    </label>
                                </div>

                                <div className="relative pb-1 pt-2 mt-2 mb-3">
                                    <input
                                        type="text"
                                        name="itemName"
                                        {...register("itemName")}
                                        defaultValue={previousData.name}
                                        id="itemName"
                                        placeholder=" "
                                        className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        
                                        required
                                    />

                                    <label
                                        htmlFor="itemName"
                                        className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                        Write item name *
                                    </label>
                                </div>

                                <div className="border border-1 ring-1 rounded-md p-3 my-5">
                                    <label htmlFor="">Attributes</label>
                                    <SpecAttributes
                                        selectedGlobalCategory={selectedGlobalCategory}
                                        specValue={specValue}
                                        setSpecValue={setSpecValue}
                                    />
                                </div>

                                <div className="py-2 mt-1 relative">
                                    <select
                                        name="unit"
                                        {...register("unit")}
                                        id="unit"
                                        defaultValue={previousData.unit ?? ""}
                                        className="w-full rounded border-solid border border-dark-white "
                                        disabled={!isAdmin}
                                        required
                                    >
                                        <option value="" hidden>
                                            Select unit
                                        </option>
                                        {mou.map((val, index) => (
                                            <option
                                                key={index}
                                                value={val.name}
                                                className="text-black"
                                            >
                                                {val.name}
                                            </option>
                                        ))}
                                    </select>

                                    <label
                                        htmlFor="storeCategory"
                                        className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:opacity-100 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                        Select unit *
                                    </label>
                                </div>

                                <div className="relative -pb-1 mt-3 mb-2">
                                    <input
                                        type="text"
                                        pattern="[0-9.]*"
                                        name="tradePrice"
                                        id="tradePrice"
                                        onChange={tradePriceChange}
                                        value={tradePrice}
                                        placeholder=" "
                                        className="w-full rounded border-solid border border-red-600 placeholder:text-red-600 appearance-none focus:outline-none focus:ring-0 focus:border-red-700 peer"
                                    />

                                    <label
                                        htmlFor="tradePrice"
                                        className="absolute text-base text-red-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                        Write item trade price (Trade Price will not be effected in
                                        sale)
                                    </label>
                                </div>

                                <div className="relative mt-2 pb-1 pt-2 mb-2">
                                    <input
                                        type="text"
                                        pattern="[0-9.]*"
                                        name="unitPrice"
                                        id="unitPrice"
                                        onChange={unitPriceChange}
                                        value={unitPrice}
                                        readOnly={!isAdmin}
                                        placeholder=" "
                                        className="pl-14 w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        required={true}
                                    />

                                    <label
                                        id="unitPrice_label"
                                        htmlFor="unitPrice"
                                        className="absolute pl-2 pt-1 text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                        Unit price (MRP) *
                                    </label>

                                    <span
                                        style={{
                                        position: "absolute",
                                        float: "left",
                                        display: "flex",
                                        zIndex: "99",
                                        marginTop: "-33px",
                                        marginLeft: "12px",
                                        fontWeight: "600",
                                        }}
                                    >
                                        BDT
                                    </span>
                                </div>

                                <div className="flex items-center relative pb-4 pt-2">
                                    <p>Is Popular</p>
                                    <label className="toggle ml-5">
                                        <input
                                            id="is_popular"
                                            name="is_popular"
                                            className="toggle-checkbox"
                                            {...register("is_popular")}
                                            defaultChecked={previousData.is_popular ? true : false}
                                            type="checkbox"
                                            placeholder="is_popular"
                                            {...register("is_popular")}
                                            disabled={!isAdmin}
                                        />
                                        <div className="toggle-switch"></div>
                                        <span className="toggle-label"></span>
                                    </label>
                                </div>

                                {/* Search Tags */}
                                <div className="relative my-3">
                        <textarea
                            type="text"
                            pattern="[A-Za-z0-9]*"
                            rows="4"
                            name="searchTag"
                            id="searchTag"
                            onKeyUp={(event) => searchTagEvent(event.target.value)}
                            defaultValue={previousData?.search_tag ?? ""}
                            placeholder=" "
                            className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer resize-none"
                            maxLength={255}

                        ></textarea>

                                    <label
                                        htmlFor="searchTag"
                                        className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 -mt-1.5"
                                    >
                                        Write Search Tags (optional)
                                    </label>
                                </div>

                                {/* <div className="relative pb-1 pt-1 mb-1">
                                            <select name="itemCategory" id="itemCategory" {...register("itemCategory")} defaultValue={previousData.category.id} className='w-full rounded border-solid border border-dark-white' required>
                                                <option value="" hidden>Select a category</option>
                                                {categoryList.map((data, index) => (
                                                    <option key={index} value={data.id} className='text-black'>{data.name}</option>
                                                ))}
                                            </select>


                                            <label htmlFor="itemCategory" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Write a category</label>
                                        </div> */}
                            </div>
                            {/* <div className="bg-[#F5F5F5] opacity-80 h-[.8px] my-5"></div> */}
                            <h1 className="text-xl">Item Details</h1>
                            <div className="mt-[5px] mb-[15px]">
                                {/* <div className="relative pb-1 pt-1 mb-1">
                                            <input type="number" name="barcodeNumber" {...register("barcodeNumber")} defaultValue={previousData.barcode} id="barcodeNumber" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                            <label htmlFor="barcodeNumber" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Barcode number</label>
                                        </div> */}

                                <textarea
                                    id="description"
                                    name="description"
                                    {...register("description")}
                                    defaultValue={previousData.description}
                                    rows={10}
                                    className=" mt-3 block p-2.5 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Write your item details here..."
                                ></textarea>

                                <div className="relative pb-1 pt-1 mb-1 mt-5">
                                    <input
                                        type="text"
                                        name="sku"
                                        {...register("sku")}
                                        defaultValue={previousData.sku ?? ""}
                                        id="sku"
                                        placeholder=" "
                                        className="text-md w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    />

                                    <label
                                        htmlFor="sku"
                                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                        SKU / Plan Code / Other Identity
                                    </label>
                                </div>

                                {file && (
                                    <div className="flex justify-center my-5">
                                        <img
                                            src={file}
                                            alt="store item preview"
                                            className="h-[100px] "
                                        />
                                    </div>
                                )}

                                <input
                                    type="file"
                                    name="image"
                                    className="hidden"
                                    ref={fileInput}
                                    onChange={handleChange}
                                />

                                <button
                                    type="Button"
                                    className="w-full  text-white bg-[#1A202C] mt-3 py-[12px] px-[32px] h-[48px] rounded-[3px] cursor-pointer flex justify-center mb-3 "
                                    onClick={selectFile}
                                >
                                    Update Featured Image
                                </button>

                                {/* Here More Images */}
                                <input
                                    ref={inputRef}
                                    type="file"
                                    style={{display: "none"}}
                                    multiple={true}
                                    onChange={handleMoreImage}
                                />
                                <label
                                    onDragEnter={handleDrag}
                                    onDrop={handleDrop}
                                    id="label-file-upload"
                                    htmlFor="input-file-upload"
                                    className={dragActive ? "drag-active" : ""}
                                >
                                    <div>
                                        <img
                                            src={FileUploadIcon}
                                            alt="More Images"
                                            style={{
                                                maxHeight: "100px",
                                                display: "block",
                                                margin: "10px auto 10px",
                                            }}
                                        />
                                        <div className="text-center">
                                            <p className="text-md text-[#999999] font-medium">
                                                Drag & Drop more images here (Max {PRODUCT_MORE_IMAGE} images)
                                            </p>
                                            <p> or </p>

                                            <button
                                                type="button"
                                                className="button border border-solid-black mt-2 px-4 py-1 bg-black text-sm text-white rounded hover:text-black hover:bg-white"
                                                onClick={onButtonClick}
                                            >
                                                Choose file
                                            </button>

                                            <p className="my-4 text-base text-[#999999]">
                                                File format should be image/*.
                                                <br/>
                                                File size should be {PRODUCT_IMAGE_D_W} X{" "}
                                                {PRODUCT_IMAGE_D_H} or more with same ratio
                                            </p>
                                        </div>
                                    </div>
                                </label>
                                {dragActive && (
                                    <div
                                        id="drag-file-element"
                                        onDragEnter={handleDrag}
                                        onDragLeave={handleDrag}
                                        onDragOver={handleDrag}
                                        onDrop={handleDrop}
                                    ></div>
                                )}
                            </div>

                            <div id="PreviewList" className="border rounded-lg shadow">
                                <table className="min-w-full divide-y divide-gray-200 custom-table-hover ">
                                    <thead className="font-semibold bg-[#F5F5F5]">
                                    <tr className="text-left" style={{fontSize: "13px"}}>
                                        <th
                                            className="p-2 text-center"
                                            style={{width: "50px"}}
                                            scope="col"
                                        >
                                            #
                                        </th>
                                        <th className="p-2 text-left">Name</th>
                                        <th
                                            className="p-2 text-center"
                                            style={{width: "80px"}}
                                            scope="col"
                                        >
                                            Pre
                                        </th>
                                        <th
                                            className="p-2 text-center"
                                            style={{width: "100px"}}
                                            scope="col"
                                        >
                                            Size (KB)
                                        </th>
                                        <th
                                            className="p-2 text-center"
                                            style={{width: "60px"}}
                                        ></th>
                                    </tr>
                                    </thead>
                                    <tbody
                                        style={{fontSize: "13px"}}
                                        className="divide-y divide-gray-200"
                                    >

                                    {moreFile &&
                                        moreFile.map((val, i) => {
                                            if( typeof(val) === "object" ) {
                                                return (
                                                    <tr className="more_images" key={i}>
                                                        <td className="p-2 border-r-2 text-center font-semibold">
                                                            {i+1}
                                                        </td>
                                                        <td className="p-2 border-r-2 text-left">
                                                            {val.name}
                                                        </td>
                                                        <td className="p-2 border-r-2 text-center">
                                                            <img
                                                                style={{
                                                                    width: "50px",
                                                                    height: "50px",
                                                                    margin: "auto",
                                                                }}
                                                                src={window.URL.createObjectURL(val)}
                                                                alt="More"
                                                            />
                                                        </td>
                                                        <td className="p-2 border-r-2 text-center">
                                                            {(val.size / 1000).toFixed(2)}
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <div className="flex cursor-pointer" onClick={() => removeMoreImage(i)}>
                                                                <img style={{width: "20px", margin: "auto"}} src={TrashIcon} alt="Cross icon" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                            else {
                                                return (
                                                    <tr className="more_images" key={i}>
                                                        <td className="p-2 border-r-2 text-center font-semibold">
                                                            {i+1}
                                                        </td>
                                                        <td className="p-2 border-r-2 text-left">
                                                            Image # {i+1}
                                                        </td>
                                                        <td className="p-2 border-r-2 text-center">
                                                            <img
                                                                style={{
                                                                    width: "50px",
                                                                    height: "50px",
                                                                    margin: "auto",
                                                                }}
                                                                src={val}
                                                                alt="More"
                                                            />
                                                        </td>
                                                        <td className="p-2 border-r-2 text-center">
                                                            -
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <div className="flex cursor-pointer" onClick={() => removeMoreImage(i)}>
                                                                <img style={{width: "20px", margin: "auto"}} src={TrashIcon} alt="Cross icon" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        })}
                                    </tbody>
                                </table>
                            </div>


                            {/* stock & addons */}
                            <div id="edit_quantity_div" className="flex items-center justify-between mt-5 py-4 border border-[#e5e7eb] rounded-md px-4 w-full">
                                
                                    <h1 className="text-xl py-2">
                                        Stock Details
                                    </h1>

                                    {previousData.is_code === true ? 
                                    <p className="flex py-2 items-center font-semibold">
                                        <div id="current_quantity" className="text-2xl ml-3" title="Current Available Stock">
                                            code
                                        </div>
                                    </p>
                                    :
                                    <div className="relative font-semibold">
                                        <input
                                        type="text"
                                        id="quantity"
                                        name="quantity"
                                        {...register("quantity")}
                                        value={quantityInput}
                                        onChange={quantityInputHandler}
                                        placeholder=" "
                                        className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        maxLength={5}
                                        />

                                        <label htmlFor="quantity" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-4 left-1.5">
                                            Enter Quantity
                                        </label>
                                    </div>
                                    }
                            </div>


                            {/* Custom Quantity */}
                            {(previousData.is_code) &&
                                <>
                                {(!previousData.is_publish) && 
                                    <div id="custom_code_div"
                                        className="flex mt-5 items-center justify-between border border-[#e5e7eb] rounded-md py-3 px-4 w-full">
                                        <h1 className="text-base font-semibold pl-1 pr-4 w-1/3">
                                            Code CSV
                                            <Link
                                                to={ExampleCustomCodeTemplate}
                                                download="Example-custom-code-template"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-xs font-normal block -mt-1 text-blue-500"
                                            >
                                                Download Sample
                                            </Link>
                                        </h1>
                                        <div className="w-2/3 flex relative bg-[#f5f5f5] p-2 rounded-md"
                                            style={{border: "1px solid #e0e0e0", marginLeft: "55px"}}>
                                            <input
                                                type="file"
                                                name="code_csv"
                                                id="code_csv"
                                                className="hidden"
                                                ref={fileInput2}
                                                onChange={handleChange2}
                                            />

                                            {file2 ? (
                                                <>
                                        <span className="text-sm pt-[6px]" title={file2.name}>
                                        {file2.name.toString().substring(0, 28)}
                                            {file2.name.length > 28 && <>...</>}
                                        </span>
                                                    <button
                                                        type="button"
                                                        className="text-white ml-auto float-right order-3 bg-[#444] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs"
                                                        onClick={selectFile2}
                                                    >
                                                        Change
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <label
                                                        htmlFor="logo"
                                                        className="p-1 pt-[5px] text-base font-medium"
                                                    >
                                                        Upload Code CSV
                                                    </label>
                                                    <button
                                                        type="button"
                                                        className="text-white ml-auto order-2 bg-[#1A202C] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-sm"
                                                        onClick={selectFile2}
                                                    >
                                                        Upload
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                }
                                </>
                            }

                            <br/>

                            
                            {(!previousData.is_code) &&
                                <>
                                    <h1 className="text-xl py-1">Variant Details</h1>

                                    {/* Addons Box */}
                                    <div id={`addons_box_0`} className="addons_box block rounded-md py-5 px-4 mt-2 pt-3 w-full">
                                    
                                        <span className="float-left" style={{fontSize: "14px", paddingLeft: "4px"}}>Variant Name</span>
                                        <div onClick={clearFirstVariantBoxData} className="text-[#FD171B] flex float-right items-center font-semibold cursor-pointer close-btn">
                                            <span className="ml-1 text-[12px] float-right">Clear</span>
                                        </div>

                                        {/* Addons Basics */}
                                        <div className="w-full flex">
                                            <div className="flex items-center pt-1 w-full">
                                                <input type="text" id={`variant_name_0`} defaultValue={existingAddons[0]?.name ?? ""} onKeyDown={onEnterAddonsName} name="variant_name" placeholder="Variant Name" className="variant_name w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-[#75b1f1] dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#75b1f1] peer" />

                                                <span className="bg-[#E5F9EA] block text-[#009E22] ml-2.5 -mr-1 px-2 py-1 h-6 text-[10px] font-medium rounded-3xl">
                                                    Required
                                                </span>
                                            </div>
                                        </div>

                                        {/* Fixed Addons Options */}
                                        <div id="variant-option-fixed_0" className="variant-option-fixed py-3">
                                            {existingAddons[0]?.items?.map((val, j)=> 
                                                <span key={j} id={`variant_options_items_${j}`} className="variant_options_items">
                                                    <div className="flex items-center pt-2">
                                                        <img src={RadioIcon2} alt="Variant Option" className="vo_radio_icon h-[18px]" />
                                                        <div className="flex justify-between w-full pl-2">
                                                            <input type="hidden" className="addons-item-id" value={val?.id} />
                                                            <input type="hidden" name="addons-item-images" className="addons-item-images" value={val?.images} />
                                                            <div contentEditable={true} onKeyDown={(e)=>addonsItemNameEvent(e)} className="w-[64%] pl-0 pt-0.5 addons-item-name">{val?.name}</div>
                                                            <div className="ml-2 w-[18%] pl-2 pt-1 text-center">
                                                                ৳ <span contentEditable={true} onKeyDown={(e)=>addonsItemPriceEvent(e)} className="addons-item-price" style={{marginLeft: "7px"}}>{val?.unit_price}</span>
                                                            </div>
                                                            <div className="ml-2 w-[18%] pl-3 pt-1 text-center">
                                                                <span className="font-semibold">x</span>
                                                                <span contentEditable={true} onKeyDown={(e)=>addonsItemQtyEvent(e)} className="addons-item-quantity" style={{marginLeft: "7px"}}>{val?.quantity}</span>
                                                            </div>
                                                            <div onClick={()=>removeVariantOption(j)} className="h-6 w-6 flex items-center mt-1 cursor-pointer">
                                                                <img src={CrossIcon} alt="Img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* more images */}
                                                    <div id={`select_more_image_${j}`} className="w-full flex mt-1 select_more_image"></div>
                                                </span>
                                            )}
                                        </div>
                                        


                                        {/* Addons Options */}
                                        <div id="variant-option_0" className="variant-option flex items-center mb-1">
                                            <img src={RadioIcon2} alt="Variant Option" className="vo_checkbox_icon h-[18px]" />
                                            <div className="flex justify-between w-full pl-2 gap-3 ">
                                                
                                                {/* Name */}
                                                <input type="text" name="variant-item" onKeyDown={onEnterAddonsItemName} className="variant-item w-[64%] pl-0 variant-item border-transparent focus:border-[#75b1f1] focus:ring-0 mr-3" placeholder="Add Variant Item" maxLength={100} />

                                                {/* Price */}
                                                <div className="relative group w-[18%]">
                                                    <input type="text" name="add-price" onKeyDown={onEnterAddonsItemPrice} className="peer add-price ml-2 w-full text-center border-transparent focus:border-[#75b1f1] focus:ring-0 focus:outline-none" placeholder="Price" maxLength={6} />
                                                    
                                                    <div className="absolute top-full text-center mt-1 hidden w-full rounded bg-[#75b1f1] p-0.5 text-xs text-white group-hover:hidden peer-focus:block">Additional Price</div>
                                                </div>

                                                {/* Quantity */}
                                                <input type="text" name="add-quantity" onKeyDown={(e)=>onEnterAddonsItemQuantity(e, 0)} className="add-quantity ml-2 w-[18%] text-center border-transparent focus:border-[#75b1f1] focus:ring-0" placeholder="Quantity" maxLength={4} />
                                            </div>
                                        </div>
                                    </div>

                                    <span id="addons_boxes">
                                    {existingAddons?.length > 1 && (
                                        <>
                                            {existingAddons.map((val, i) => {
                                                if (i === 0) {
                                                    return null; // Skip the first item
                                                }

                                                return (
                                                <div key={i} id={`addons_box_`+i} className="addons_box block rounded-md py-5 px-4 mt-3 pt-3 w-full">
                                    
                                                    <span className="float-left" style={{fontSize: "14px", paddingLeft: "4px"}}>Variant Name</span>
                                                    <div onClick={()=>removeVariantBox(i)} className="text-[#FD171B] flex float-right items-center font-semibold cursor-pointer close-btn">
                                                        <img src={AddonsRemoveIcon} alt="Img" />
                                                        <span className="ml-1 text-[12px] float-right">Remove</span>
                                                    </div>

                                                    {/* Addons Basics */}
                                                    <div className="w-full flex">
                                                        <div className="flex items-center pt-1 w-full">
                                                            <input type="text" id={`variant_name_${i}`} defaultValue={val?.name ?? ""} onKeyDown={onEnterAddonsName} name="variant_name" placeholder="Variant Name" className="variant_name w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-[#75b1f1] dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-[#75b1f1] peer" />

                                                            <span className="bg-[#E5F9EA] block text-[#009E22] ml-2.5 -mr-1 px-2 py-1 h-6 text-[10px] font-medium rounded-3xl">
                                                                Required
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Fixed Addons Options */}
                                                    <div id={`variant-option-fixed_${i}`} className="variant-option-fixed py-3">
                                                        {existingAddons[i]?.items?.map((val, j)=> 
                                                            <span key={j} id={`variant_options_items_${i+j+1}`} className="variant_options_items">
                                                                <div className="flex items-center pt-2">
                                                                    <img src={RadioIcon2} alt="Variant Option" className="vo_radio_icon h-[18px]" />
                                                                    <div className="flex justify-between w-full pl-2">
                                                                        <input type="hidden" name="addons-item-id" className="addons-item-id" value={val?.id} />
                                                                        <input type="hidden" name="addons-item-images" className="addons-item-images" value={val?.images} />
                                                                        <div contentEditable={true} onKeyDown={(e)=>addonsItemNameEvent(e)} className="w-[64%] pl-0 pt-0.5 addons-item-name">{val?.name}</div>
                                                                        <div className="ml-2 w-[18%] pl-2 pt-1 text-center">
                                                                            ৳ <span contentEditable={true} onKeyDown={(e)=>addonsItemPriceEvent(e)} className="addons-item-price" style={{marginLeft: "7px"}}>{val?.unit_price}</span>
                                                                        </div>
                                                                        <div className="ml-2 w-[18%] pl-3 pt-1 text-center">
                                                                            <span className="font-semibold">x</span>
                                                                            <span contentEditable={true} onKeyDown={(e)=>addonsItemQtyEvent(e)} className="addons-item-quantity" style={{marginLeft: "7px"}}>{val?.quantity}</span>
                                                                        </div>
                                                                        <div onClick={()=>removeVariantOption(i+j+1)} className="h-6 w-6 flex items-center mt-1 cursor-pointer">
                                                                            <img src={CrossIcon} alt="Img" />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* more images */}
                                                                <div id={`select_more_image_${i+j+1}`} className="w-full flex mt-1 select_more_image"></div>
                                                            </span>
                                                        )}
                                                    </div>


                                                    {/* Addons Options */}
                                                    <div id={`variant-option_${i}`} className="variant-option flex items-center mb-1">
                                                        <img src={RadioIcon2} alt="Variant Option" className="vo_checkbox_icon h-[18px]" />
                                                        <div className="flex justify-between w-full pl-2 gap-3 ">
                                                            
                                                            {/* Name */}
                                                            <input type="text" name="variant-item" onKeyDown={onEnterAddonsItemName} className="variant-item w-[64%] pl-0 variant-item border-transparent focus:border-[#75b1f1] focus:ring-0 mr-3" placeholder="Add Variant Item" maxLength={100} />

                                                            {/* Price */}
                                                            <div className="relative group w-[18%]">
                                                                <input type="text" name="add-price" onKeyDown={onEnterAddonsItemPrice} className="peer add-price ml-2 w-full text-center border-transparent focus:border-[#75b1f1] focus:ring-0 focus:outline-none" placeholder="Price" maxLength={6} />
                                                                
                                                                <div className="absolute top-full text-center mt-1 hidden w-full rounded bg-[#75b1f1] p-0.5 text-xs text-white group-hover:hidden peer-focus:block">Additional Price</div>
                                                            </div>

                                                            {/* Quantity */}
                                                            <input type="text" name="add-quantity" onKeyDown={(e)=>onEnterAddonsItemQuantity(e, i)} className="add-quantity ml-2 w-[18%] text-center border-transparent focus:border-[#75b1f1] focus:ring-0" placeholder="Quantity" maxLength={4} />
                                                        </div>
                                                    </div>
                                                </div>
                                                ); 
                                            })}
                                        </>
                                    )}
                                    </span>

                                    <button type="Button" onClick={addMoreVariant} className="w-full text-white bg-[#1A202C] py-[12px] px-[32px] h-[48px] rounded-[3px] cursor-pointer flex justify-center my-4">
                                        <span className="mr-2.5">
                                            <img src={PlusImage} alt="Plus Sign"></img>
                                        </span>
                                        Add More Variant
                                    </button>
                                    
                                </>
                            }

                            {/* Low Stock Alert */}
                            <div className="block border border-[#e5e7eb] rounded-md py-5 px-4 mb-5">
                                <label className="toggle my-1 w-full">
                                    <input
                                        id="apply_item_or_category"
                                        name="apply_item_or_category"
                                        {...register("apply_item_or_category")}
                                        onChange={(event) => lowStockSwitch(event)}
                                        defaultChecked={
                                            previousData.low_stock_alert > 0 ? true : false
                                        }
                                        className="toggle-checkbox"
                                        value="1"
                                        type="checkbox"
                                        disabled={!isAdmin}
                                    />
                                    <div className="toggle-switch float-right"></div>
                                    <span className="toggle-label text-base font-semibold">
                                        Low Stock Alert
                                    </span>
                                </label>

                                <div id="low_stock_alert_div">
                                    <div className="relative mt-2 pb-1 pt-1 mb-1">
                                        <input
                                            defaultValue={previousData?.low_stock_alert ?? null}
                                            type="text"
                                            name="low_stock_alert"
                                            id="low_stock_alert"
                                            placeholder=" "
                                            className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                            
                                        />

                                        <label
                                            htmlFor="low_stock_alert"
                                            className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                        >
                                            Alert Quantity
                                        </label>
                                    </div>
                                </div>
                            </div>


                            {/* Delivery Info */}
                            <div className="block border border-[#e5e7eb] rounded-md py-3 px-4 mt-4 mb-5">
                                <label className="toggle my-1 w-full">
                                    <input
                                        id="apply_delivery_info"
                                        name="apply_delivery_info"
                                        {...register("apply_delivery_info")}
                                        defaultChecked={previousData.delivery ? true : false}
                                        onChange={(event) => deliveryInfoSwitch(event)}
                                        className="toggle-checkbox"
                                        value={previousData.delivery ? 1 : 0}
                                        type="checkbox"
                                    />
                                    <div className="toggle-switch float-right"></div>
                                    <span className="toggle-label text-base font-semibold">
                            Delivery Info
                        </span>
                        </label>

                                {previousData.delivery ? (
                                    <div className="w-full py-2" id="apply_delivery_info_div">
                                        <div className="flex">
                                            {/* Delivery Charge */}
                                            <div className="relative pb-1 pt-2 w-1/2">
                                                <input
                                                    type="number"
                                                    name="charge_inside"
                                                    {...register("charge_inside")}
                                                    value={insideDeliveryCharge}
                                                    onChange={insideDeliveryChargeHandler}
                                                    id="charge_inside"
                                                    placeholder=" "
                                                    className="rounded w-full border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="charge_inside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Charge Inside
                                                </label>
                                            </div>

                                            <div className="relative ml-2 pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="charge_outside"
                                                    {...register("charge_outside")}
                                                    value={outsideDeliveryCharge}
                                                    onChange={outsideDeliveryChargeHandler}
                                                    id="charge_outside"
                                                    placeholder=" "
                                                    className="rounded w-full border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="charge_outside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Charge Outside
                                                </label>
                                            </div>
                                        </div>

                                        <div className="flex mt-3 mb-2">
                                            {/* Delivery Duration */}
                                            <div className="relative pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="time_inside"
                                                    {...register("time_inside")}
                                                    value={insideDeliveryTime}
                                                    onChange={insideDeliveryTimeHandler}
                                                    id="time_inside"
                                                    placeholder=" "
                                                    className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="time_inside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Time Inside
                                                </label>
                                            </div>

                                            <div className="relative ml-2 pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="time_outside"
                                                    {...register("time_outside")}
                                                    value={outsideDeliveryTime}
                                                    onChange={outsideDeliveryTimeHandler}
                                                    id="time_outside"
                                                    placeholder=" "
                                                    className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="time_outside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Min Time Outside
                                                </label>
                                            </div>
                                            <div className="relative ml-2 pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="time_outside_end"
                                                    {...register("time_outside_end")}
                                                    value={outsideDeliveryTimeEnd}
                                                    onChange={outsideDeliveryTimeHandlerEnd}
                                                    id="time_outside_end"
                                                    placeholder=" "
                                                    className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                    
                                                />
                                                <label
                                                    htmlFor="time_outside_end"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Max Time Outside
                                                </label>
                                            </div>
                                        </div>

                                        <div className="flex mt-3 mb-2">
                                            <div className="relative pb-1 pt-2 w-full">
                                    <textarea
                                        type="text"
                                        name="delivery_notes"
                                        {...register("delivery_notes")}
                                        value={deliveryNotes}
                                        onChange={(e) => setDeliveryNotes(e.target.value)}
                                        id="delivery_notes"
                                        maxLength={500}
                                        rows={5}
                                        placeholder=" "
                                        className="w-full resize-none rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        
                                    />
                                                <label
                                                    htmlFor="delivery_notes"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Delivery Notes (Optional)
                                                </label>
                                            </div>
                                        </div>


                                    </div>
                                ) : (
                                    <div className="w-full hidden py-2" id="apply_delivery_info_div">
                                        <div className="flex">
                                            {/* Delivery Charge */}
                                            <div className="relative pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="charge_inside"
                                                    {...register("charge_inside")}
                                                    value={insideDeliveryCharge}
                                                    onChange={insideDeliveryChargeHandler}
                                                    id="charge_inside"
                                                    placeholder=" "
                                                    className="rounded w-full border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="charge_inside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Charge Inside
                                                </label>
                                            </div>

                                            <div className="relative ml-2 pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="charge_outside"
                                                    {...register("charge_outside")}
                                                    value={outsideDeliveryCharge}
                                                    onChange={outsideDeliveryChargeHandler}
                                                    id="charge_outside"
                                                    placeholder=" "
                                                    className="rounded w-full border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="charge_outside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Charge Outside
                                                </label>
                                            </div>
                                        </div>

                                        <div className="flex mt-3 mb-2">
                                            {/* Delivery Duration */}
                                            <div className="relative pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="time_inside"
                                                    {...register("time_inside")}
                                                    value={insideDeliveryTime}
                                                    onChange={insideDeliveryTimeHandler}
                                                    id="time_inside"
                                                    placeholder=" "
                                                    className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="time_inside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Time Inside
                                                </label>
                                            </div>

                                            <div className="relative ml-2 pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="time_outside"
                                                    {...register("time_outside")}
                                                    value={outsideDeliveryTime}
                                                    onChange={outsideDeliveryTimeHandler}
                                                    id="time_outside"
                                                    placeholder=" "
                                                    className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />

                                                <label
                                                    htmlFor="time_outside"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Min Time Outside
                                                </label>
                                            </div>
                                            <div className="relative ml-2 pb-1 pt-2 w-1/2">
                                                <input
                                                    type="text"
                                                    name="time_outside_end"
                                                    {...register("time_outside_end")}
                                                    value={outsideDeliveryTimeEnd}
                                                    onChange={outsideDeliveryTimeHandlerEnd}
                                                    id="time_outside_end"
                                                    placeholder=" "
                                                    className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                    maxLength={5}
                                                />
                                                <label
                                                    htmlFor="time_outside_end"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Max Time Outside
                                                </label>
                                            </div>
                                        </div>

                                        <div className="flex mt-3 mb-2">
                                            <div className="relative pb-1 pt-2 w-full">
                                    <textarea
                                        type="text"
                                        name="delivery_notes"
                                        {...register("delivery_notes")}
                                        value={deliveryNotes}
                                        onChange={(e) => setDeliveryNotes(e.target.value)}
                                        id="delivery_notes"
                                        maxLength={500}
                                        rows={5}
                                        placeholder=" "
                                        className="w-full resize-none rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        
                                    />
                                                <label
                                                    htmlFor="delivery_notes"
                                                    className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                                >
                                                    Delivery Notes (Optional)
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                )}
                            </div>


                            <br/><br/><br/>

                        </main>
                    </form>

                    <style>{`
                        * :disabled {
                            background-color: #F5F5F5 !important;
                        }

                        .select_more_image {
                            border: 1px dotted #dbdbdb;
                            border-radius: 5px;
                        }

                        .vi-selected {
                            --tw-bg-opacity: 1 !important;
                            background-color: rgb(220 38 38 / var(--tw-bg-opacity)) !important;
                        }

                        .addons_box {
                            border: 2px dotted rgb(117, 177, 241);
                        }

                        label > input[type='radio'], input[type="radio"] {
                            display: none;
                        }

                        label > input[type="radio"] + *::before {
                            color: #158560 !important;
                            content: " ";
                            display: inline-grid;
                            width: 1.1rem;
                            height: 1.1rem;
                            border-radius: 50%;
                            border-style: solid;
                            border-width: 0.1rem;
                            border-color: #158560;
                            margin-top: 5px;
                        }

                        label > input[type="radio"]:checked + *::before {
                            background: radial-gradient(#158560 0%, #158560 40%, transparent 50%, transparent);;
                            border-color: #158560;
                        }

                        label > input[type="radio"] + * {
                            display: inline-block;
                            padding: 0.5rem;
                        }

                        #option-1:checked:checked ~ .option-1,
                        #option-2:checked:checked ~ .option-2,
                        #option-3:checked:checked ~ .option-3,
                        #option-4:checked:checked ~ .option-4{
                            border-color: #158560;
                            background: #158560;
                        }
                        #option-1:checked:checked ~ .option-1 .dot,
                        #option-2:checked:checked ~ .option-2 .dot,
                        #option-3:checked:checked ~ .option-3 .dot,
                        #option-4:checked:checked ~ .option-4 .dot{
                            background: #fff;
                        }
                        #option-1:checked:checked ~ .option-1 .dot::before,
                        #option-2:checked:checked ~ .option-2 .dot::before,
                        #option-3:checked:checked ~ .option-3 .dot::before,
                        #option-4:checked:checked ~ .option-4 .dot::before{
                            opacity: 1;
                            transform: scale(1);
                        }
                        .wrapper .option span{
                            font-size: 17px;
                            color: #808080;
                        }
                        #option-1:checked:checked ~ .option-1 span,
                        #option-2:checked:checked ~ .option-2 span,
                        #option-3:checked:checked ~ .option-3 span,
                        #option-4:checked:checked ~ .option-4 span{
                            color: #fff;
                        }


                        {/* Toggle Switcher */}
                        .toggle {
                            cursor: pointer;
                            display: inline-block;
                        }

                        .toggle-switch {
                            display: inline-block;
                            background: #ccc;
                            border-radius: 16px;
                            width: 42px;
                            height: 23px;
                            position: relative;
                            vertical-align: middle;
                            transition: background 0.25s;
                        }
                        .toggle-switch:before, .toggle-switch:after {
                            content: "";
                        }
                        .toggle-switch:before {
                            display: block;
                            background: linear-gradient(to bottom, #fff 0%, #eee 100%);
                            border-radius: 50%;
                            box-shadow: 0 0 0 1px rgb(0 0 0 / 25%);
                            width: 17px;
                            height: 17px;
                            position: absolute;
                            top: 3px;
                            left: 4px;
                            transition: left 0.25s;
                        }
                        .toggle:hover .toggle-switch:before {
                            background: linear-gradient(to bottom, #fff 0%, #fff 100%);
                            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
                        }
                        .toggle-checkbox:checked + .toggle-switch {
                            background: #158560;

                        }
                        .toggle-checkbox:checked + .toggle-switch:before {
                            left: 22px;
                        }

                        .toggle-checkbox {
                            position: absolute;
                            visibility: hidden;
                        }

                        .toggle-label {
                            margin-left: 5px;
                            position: relative;
                            top: 2px;
                            font-size: 16px;
                        }

                        {/* Toggle Switcher End */}


                        {/* Option Value */}
                        select option[value="radio"] {
                            background-image:url(${RadioIcon}) !important;
                        }

                        .variant-item, .add-price, .add-quantity {
                            margin: 2px 0;
                            box-sizing: border-box;
                            border: none;
                            height: 30px;
                            border-bottom: 2px solid #DDDDDD;
                            font-size: 15px;
                        }


                        {/* SELECT BOX with Image */}
                        div.mm-dropdown {
                            border: 1px solid #ddd;
                            width: 100%;
                            border-radius: 3px;
                        }

                        div.mm-dropdown ul {
                            list-style: none;
                            padding: 0;
                            margin: 0;
                            position: absolute;
                            background: white;
                            width: 100%;
                            z-index: 999999;
                            margin-left: -1px;
                        }


                        div.mm-dropdown ul li,
                        div.mm-dropdown div.textfirst {
                            padding: 0;
                            color: #333;
                            padding: 5px 15px;
                        }

                        div.mm-dropdown ul li.input-option, div.mm-dropdown div.textfirst {
                            display: flex;
                            align-items: center;
                        }

                        div.mm-dropdown ul li.input-option {
                            border: 1px solid #ddd !important;
                        }

                        div.mm-dropdown div.textfirst {
                            border: 0 !important;
                            padding-top: 8px;
                            padding-bottom: 8px;
                        }

                        div.mm-dropdown div.textfirst span {
                            width: 100% !important;
                        }

                        div.mm-dropdown div.textfirst img {
                            margin-right: 10px;
                        }

                        div.mm-dropdown div.textfirst img.down {
                            float: right;
                        }

                        div.mm-dropdown ul li:last-child {
                            border-bottom: 0;
                        }

                        div.mm-dropdown ul li {
                            display: none;
                            padding-left: 15px;
                        }

                        div.mm-dropdown ul li.main {
                            display: block;
                        }

                        div.mm-dropdown ul li img {
                            width: 20px;
                            height: 20px;
                            margin-right: 10px;
                        }

                        .checkbox_div, .radio_div {
                            height: 18px;
                            width: 18px;
                            border: 2px solid #E5E5E5; 
                        }

                        .checkbox_div {
                            border-radius: 6px;
                        }

                        .radio_div {
                            border-radius: 50%;
                        }

                        .p-tree.p-component.p-tree-selectable {
                            max-width: 100% !important;
                        }

                        .highlight-effect {
                            background-color: #fffbcc;
                            transition: background-color 1s ease;
                        }

                        .addons-item-name[contenteditable="true"], .addons-item-quantity[contenteditable="true"], .addons-item-price[contenteditable="true"] {
                            border: 1px dotted rgb(117, 177, 241, 0.9);
                            padding-inline: 10px;
                            border-radius: 5px;
                        }

                    `}</style>
                </div>
            )}
                </>
            }
        </div>
    );
};

export default StoreItemClone;